const AccountSection = ({ children }) => {
    return (
        <div className={"border border-borderGrey rounded-md p-4 flex flex-col gap-4"}>
            {children}
        </div>
    )
}

export default AccountSection